(() => {
  'use strict';
  const searchPage = document.querySelector('[data-gg-product-search]');
  if (searchPage) {
    const url = new URL(location.href);
    const types = (url.searchParams.get('type') || '').split(',').filter(Boolean);
    const guides = types.length > 0 && types.every(type => type === 'page' || type === 'article');
    if (!guides && (types.length !== 1 || types[0] !== 'product')) {
      url.searchParams.set('type', 'product');
      url.searchParams.set('filter.v.availability', '1');
      url.searchParams.delete('page');
      location.replace(url.toString());
      return;
    }
  }
  const prepareSearchForm = form => {
    if (!form?.matches('form[role="search"][action]')) return;
    if (!new URL(form.action, location.origin).pathname.replace(/\/$/, '').endsWith('/search')) return;
    let type = form.querySelector('input[name="type"]');
    const types = (type?.value || '').split(',').filter(Boolean);
    if (types.length && types.every(value => value === 'page' || value === 'article')) return;
    const setHidden = (name, value) => {
      let input = form.querySelector('input[name="' + name + '"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        form.append(input);
      }
      input.value = value;
    };
    setHidden('type', 'product');
    if (!form.querySelector('input[name="filter.v.availability"]')) setHidden('filter.v.availability', '1');
  };
  document.querySelectorAll('form[role="search"][action]').forEach(prepareSearchForm);
  document.addEventListener('submit', event => prepareSearchForm(event.target), true);
})();
